import { useEffect } from "react";
import { useLogtoAdmin } from "@/services/auth/logto-provider";
import { LexeLogo } from "@/components/ui/LexeLogo";

export function LoginPage() {
  const { signIn, isAuthenticated, isLoading } = useLogtoAdmin();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      signIn(`${window.location.origin}/callback`);
    }
  }, [isAuthenticated, isLoading, signIn]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <div className="flex items-center justify-center">
          <LexeLogo size="xl" />
        </div>
        <p className="text-muted-foreground">Reindirizzamento al login...</p>
        <div className="h-1 w-48 mx-auto bg-muted rounded-full overflow-hidden">
          <div className="h-full w-1/3 bg-primary rounded-full animate-pulse" />
        </div>
      </div>
    </div>
  );
}
